export default "__VITE_ASSET__IK74R0yTWCNjI0r4yMeH1g__"